var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 21.334H96C43.0933 21.334 0 64.4273 0 117.334V394.667C0 447.574 43.0933 490.667 96 490.667H416C468.907 490.667 512 447.574 512 394.667V117.334C512 64.4273 468.907 21.334 416 21.334ZM96 42.6673H416C457.173 42.6673 490.667 76.1607 490.667 117.334V170.667H21.3333V117.334C21.3333 76.1607 54.8267 42.6673 96 42.6673ZM416 469.334H96C54.8267 469.334 21.3333 435.841 21.3333 394.667V192.001H490.667V394.667C490.667 435.841 457.173 469.334 416 469.334Z",
    fill: "#CD2122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.903 106.5C107.903 114.508 101.433 121 93.4516 121C85.4702 121 79 114.508 79 106.5C79 98.4919 85.4702 92 93.4516 92C101.433 92 107.903 98.4919 107.903 106.5ZM157.452 106.5C157.452 114.508 150.981 121 143 121C135.019 121 128.548 114.508 128.548 106.5C128.548 98.4919 135.019 92 143 92C150.981 92 157.452 98.4919 157.452 106.5ZM192.548 121C200.53 121 207 114.508 207 106.5C207 98.4919 200.53 92 192.548 92C184.567 92 178.097 98.4919 178.097 106.5C178.097 114.508 184.567 121 192.548 121Z",
    fill: "#CD2122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400 267H108C103.582 267 100 270.582 100 275V387C100 391.418 103.582 395 108 395H400C404.418 395 408 391.418 408 387V275C408 270.582 404.418 267 400 267ZM108 246C91.9837 246 79 258.984 79 275V387C79 403.016 91.9837 416 108 416H400C416.016 416 429 403.016 429 387V275C429 258.984 416.016 246 400 246H108Z",
    fill: "#CD2122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg6);
export default __webpack_public_path__ + "static/media/img_6.fb48f3e4d70ce4a53f08de08e58be4dd.svg";
export { ForwardRef as ReactComponent };